import dayJsLocales from '@/utils/dayjs.locales';
import dayjs from 'dayjs';

export default defineNuxtPlugin((nuxtApp) => {
  const locale = nuxtApp.vueApp.$nuxt.$i18n.locale.value;

  return {
      provide: {
        formatDate: (value: string, format = 'L') => dayjs(value)
        .locale((dayJsLocales as any)[locale.toLowerCase()])
        .format(format)
      }
  }
})